import './App.css';
import Nav from './Nav';
import Home from './Home';
import MidiDraw from './MidiDraw';
import Complexetron from './Complexetron';
import { BrowserRouter, Routes, Route } from "react-router-dom";


export default function App() {
  return (
      <BrowserRouter>
        <div className='App'>
            <Nav />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/midi-draw" element={<MidiDraw />} />
                <Route path="/complexetron" element={<Complexetron />} />
            </Routes>
              {/*<div className='App-header'>*/}
              {/*  <h1>TASHI NAMGYAL</h1>*/}
              {/*</div>*/}
              {/*<div className='App-body'>*/}
              {/*  <p>PhD Student at University of Bristol</p>*/}
              {/*</div>*/}
        </div>
      </BrowserRouter>
  );
}

